import { lazy } from 'react';

const SignUpComplete = lazy(() =>
  import(/* webpackChunkName: "SignUpComplete" */ '@common2/Authorization/SignUp/SignUpComplete')
);

export default SignUpComplete;
